module.exports = __webpack_public_path__ + "static/media/reward-catalouge-3.94075d02.png";